import { jsPDF } from "jspdf";
import html2canvas from "html2canvas";
import api from "@/lib/api";

async function getBusiness() {
  try { const { data } = await api.get("/settings"); return data || {}; }
  catch { return {}; }
}

const tk = (n) => "৳" + Number(n || 0).toLocaleString("en-US", { maximumFractionDigits: 2 });
const esc = (s) => String(s == null ? "" : s).replace(/[&<>"']/g, (c) => ({ "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[c]));

function buildHTML(inv) {
  const b = inv.business || {};
  const rows = inv.items.map((it) => `
    <tr>
      <td style="padding:8px 6px;border-bottom:1px solid #eee;">${esc(it.name)}</td>
      <td style="padding:8px 6px;border-bottom:1px solid #eee;text-align:center;">${esc(it.qty)} ${esc(it.unit || "")}</td>
      <td style="padding:8px 6px;border-bottom:1px solid #eee;text-align:right;">${tk(it.price)}</td>
      <td style="padding:8px 6px;border-bottom:1px solid #eee;text-align:right;font-weight:600;">${tk(it.total)}</td>
    </tr>`).join("");

  const logo = b.logo
    ? `<img src="${esc(b.logo)}" crossorigin="anonymous" style="width:56px;height:56px;border-radius:12px;object-fit:cover;" />`
    : `<div style="width:56px;height:56px;border-radius:12px;background:#1E3A2B;color:#CA8A04;display:flex;align-items:center;justify-content:center;font-size:18px;font-weight:700;">MD</div>`;

  return `
  <div style="border:1px solid #E7E5E4;border-radius:16px;overflow:hidden;">
    <div style="background:#1E3A2B;color:#fff;padding:22px 28px;display:flex;justify-content:space-between;align-items:center;">
      <div style="display:flex;gap:12px;align-items:center;">
        ${logo}
        <div>
          <div style="font-size:20px;font-weight:700;">${esc(b.business_name || "M.D.Rice Mill")}</div>
          <div style="font-size:12px;color:#D6E5D9;">${esc(b.address || "")}</div>
          <div style="font-size:12px;color:#D6E5D9;">${esc([b.phone, b.phone2, b.phone3].filter(Boolean).join(", "))}</div>
        </div>
      </div>
      <div style="text-align:right;">
        <div style="font-size:22px;font-weight:700;color:#FEF08A;">ইনভয়েস</div>
        <div style="font-size:13px;">${esc(inv.number)}</div>
        <div style="font-size:12px;color:#D6E5D9;">${esc(inv.date)}</div>
      </div>
    </div>
    <div style="padding:20px 28px;">
      <div style="font-size:13px;color:#57534E;margin-bottom:4px;">গ্রাহক</div>
      <div style="font-weight:600;font-size:15px;">${esc(inv.customer.name)}</div>
      <div style="font-size:13px;color:#57534E;">${esc(inv.customer.mobile || "")}</div>
      <div style="font-size:13px;color:#57534E;">${esc(inv.customer.address || "")}</div>

      <table style="width:100%;border-collapse:collapse;margin-top:18px;font-size:13px;">
        <thead>
          <tr style="background:#F5F5F4;color:#57534E;font-size:12px;">
            <th style="padding:8px 6px;text-align:left;">পণ্য</th>
            <th style="padding:8px 6px;text-align:center;">পরিমাণ</th>
            <th style="padding:8px 6px;text-align:right;">দাম</th>
            <th style="padding:8px 6px;text-align:right;">মোট</th>
          </tr>
        </thead>
        <tbody>${rows}</tbody>
      </table>

      <div style="margin-top:16px;display:flex;justify-content:flex-end;">
        <table style="font-size:13px;min-width:260px;">
          <tr><td style="padding:3px 0;color:#57534E;">সাবটোটাল</td><td style="padding:3px 0;text-align:right;">${tk(inv.subtotal)}</td></tr>
          ${inv.delivery ? `<tr><td style="padding:3px 0;color:#57534E;">ডেলিভারি</td><td style="padding:3px 0;text-align:right;">${tk(inv.delivery)}</td></tr>` : ""}
          ${inv.discount ? `<tr><td style="padding:3px 0;color:#059669;">ছাড়</td><td style="padding:3px 0;text-align:right;color:#059669;">-${tk(inv.discount)}</td></tr>` : ""}
          <tr><td style="padding:6px 0;font-weight:700;font-size:15px;color:#1E3A2B;border-top:2px solid #1E3A2B;">সর্বমোট</td><td style="padding:6px 0;text-align:right;font-weight:700;font-size:15px;color:#1E3A2B;border-top:2px solid #1E3A2B;">${tk(inv.total)}</td></tr>
          ${inv.paid != null ? `<tr><td style="padding:3px 0;color:#57534E;">পরিশোধিত</td><td style="padding:3px 0;text-align:right;">${tk(inv.paid)}</td></tr>` : ""}
          ${inv.due ? `<tr><td style="padding:3px 0;color:#DC2626;">বাকি</td><td style="padding:3px 0;text-align:right;color:#DC2626;">${tk(inv.due)}</td></tr>` : ""}
        </table>
      </div>

      <div style="margin-top:14px;font-size:13px;color:#57534E;">পেমেন্ট পদ্ধতি: <b style="color:#1c1917;text-transform:uppercase;">${esc(inv.payment_method || "-")}</b></div>
      <div style="margin-top:22px;text-align:center;font-size:12px;color:#A8A29E;border-top:1px dashed #E7E5E4;padding-top:12px;">ধন্যবাদ! আবার আসবেন — ${esc(b.business_name || "M.D.Rice Mill")}</div>
    </div>
  </div>`;
}

async function render(inv) {
  const el = document.createElement("div");
  el.style.cssText = "position:fixed;left:-9999px;top:0;width:760px;background:#fff;font-family:'Hind Siliguri',sans-serif;color:#1c1917;padding:24px;";
  el.innerHTML = buildHTML(inv);
  document.body.appendChild(el);
  try { if (document.fonts && document.fonts.ready) await document.fonts.ready; } catch {}
  await new Promise((r) => setTimeout(r, 150));
  const canvas = await html2canvas(el, { scale: 2, backgroundColor: "#ffffff", useCORS: true });
  document.body.removeChild(el);
  const img = canvas.toDataURL("image/png");
  const pdf = new jsPDF("p", "mm", "a4");
  const w = 210;
  const h = (canvas.height * w) / canvas.width;
  let heightLeft = h;
  let position = 0;
  pdf.addImage(img, "PNG", 0, position, w, h);
  heightLeft -= 297;
  while (heightLeft > 0) {
    position = heightLeft - h;
    pdf.addPage();
    pdf.addImage(img, "PNG", 0, position, w, h);
    heightLeft -= 297;
  }
  pdf.save(inv.filename);
}

export async function downloadOrderInvoice(o) {
  const business = await getBusiness();
  await render({
    business, filename: `${o.order_no}.pdf`, number: o.order_no,
    date: new Date(o.created_at).toLocaleDateString("bn-BD"),
    customer: { name: o.customer_name, mobile: o.mobile, address: `${o.address || ""}${o.upazila ? ", " + o.upazila : ""}${o.district ? ", " + o.district : ""}` },
    items: o.items.map((it) => ({ name: it.name_bn, qty: it.quantity, unit: it.unit, price: it.price, total: it.line_total })),
    subtotal: o.subtotal, delivery: o.delivery_charge, discount: o.discount, total: o.total,
    paid: o.payment_status === "paid" ? o.total : 0, due: o.payment_status === "paid" ? 0 : o.total,
    payment_method: o.payment_method,
  });
}

export async function downloadSaleInvoice(s) {
  const business = await getBusiness();
  await render({
    business, filename: `${s.invoice_no}.pdf`, number: s.invoice_no,
    date: new Date(s.date || s.created_at).toLocaleDateString("bn-BD"),
    customer: { name: s.customer_name, mobile: s.customer_mobile || "", address: "" },
    items: s.items.map((it) => ({ name: it.name_bn, qty: it.quantity, unit: it.unit, price: it.price, total: it.line_total })),
    subtotal: s.subtotal, delivery: s.delivery_charge, discount: s.discount, total: s.total,
    paid: s.paid_amount, due: s.due, payment_method: s.payment_method,
  });
}
